// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { FolderCode as RawFolderCode } from "lucide-react";
export const FolderCode = /* @__PURE__ */ createIcon(RawFolderCode, "FolderCode", 2);
